export default "__VITE_ASSET__DvUxCdR2__"